import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { useEntitiesById } from "@hooks/useEntities";
import { MatchableItem } from "../types";

export const EntityCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MatchableItem, unknown>) => {
        const { entity, entityId } = row.original;
        // Document mappers fill `entity` from `financialAccount.entity`,
        // which is missing for invoices/bills that have no financial
        // account (e.g. manually created ones). Fall back to the
        // workspace's entity cache by id so the column still renders.
        const entitiesById = useEntitiesById();
        const resolvedEntity = entity.id ? entity : entitiesById.get(entityId);

        if (!resolvedEntity) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                <EntityAvatar size="xs" entity={resolvedEntity} />
            </ViewTableCell>
        );
    },
);
EntityCell.displayName = "EntityCell";
